/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("unused", "MemberVisibilityCanBePrivate")

package js.features.conglomerateMemberships

import kangaroorewards.appsdk.core.api.Api
import kangaroorewards.appsdk.core.domain.SerializedResult
import kangaroorewards.appsdk.core.domain.toJsonResult
import kotlinx.coroutines.DelicateCoroutinesApi
import kotlinx.coroutines.GlobalScope
import kotlinx.coroutines.promise
import kotlin.js.Promise
import kotlinx.serialization.json.Json
import features.conglomerateMemberships.ConglomerateMembershipsApi
import features.conglomerateMemberships.models.Businesses
import features.conglomerateMemberships.serializeConglomerateMembershipsState



/**
 * Get the conglomerate children of a business [Api] class
 */
@OptIn(DelicateCoroutinesApi::class)
@ExperimentalJsExport
@JsExport
@JsName("ConglomerateMembershipsApi")
class ConglomerateMembershipsApiJs {

    /**
     * Get the conglomerate children of a business
     */
    fun getConglomerateMemberships(
        overrideHeaders: String?, 

    ): Promise<String?>  {
        return GlobalScope.promise {

        val decodedOverrideHeaders = if (overrideHeaders == null) {
                null
        } else {
            try {
                Json.decodeFromString<Map<String, String>>(overrideHeaders)
            } catch (e: Exception) {
                null
                }
            }

            val result = ConglomerateMembershipsApi().getConglomerateMemberships(
            overrideHeaders = decodedOverrideHeaders,
            
        ).toJsonResult<Businesses>()
        
        
            return@promise when (result) {
                is SerializedResult.Success -> result.data
                is SerializedResult.UnauthorizedError -> result.error
                is SerializedResult.UnknownError -> result.error
                else -> null
            }
        }
    }

    

    

    fun observeConglomerateMembershipsState(
        onData: (String) -> Unit,
        onStreamError: (String) -> Unit,
    ) {
        ConglomerateMembershipsApi().conglomerateMembershipsState.serializeConglomerateMembershipsState().observe { result ->
            when (result) {
                is SerializedResult.Idle -> onData(result.state)
                is SerializedResult.Loading -> onData(result.state)
                is SerializedResult.Success -> onData(result.data)
                is SerializedResult.UnauthorizedError -> onData(result.error)
                is SerializedResult.UnknownError -> onData(result.error)
                else -> onStreamError("unknown error in stream")
            }
        }
    }
}
